import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__qgiv-bookmark-filled",
  "use": "Custom__qgiv-bookmark-filled-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 14 18\" id=\"Custom__qgiv-bookmark-filled\"><path d=\"M.486 1.657v15.176c0 .463.384.84.855.84a.864.864 0 0 0 .493-.153l5.41-3.713 5.408 3.713c.144.1.317.152.493.152a.848.848 0 0 0 .855-.839V1.657C14 .743 13.243 0 12.31 0H2.177C1.243 0 .486.743.486 1.657Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol